module.exports = __webpack_public_path__ + "img/8.f730bb31.png";